import { apiService } from "./api.service";
import { IPropertyBlockBrand } from "@/models/interfaces/property/property-block-brand.model.interface";

class PropertyProductService {
    private static serviceInstance: PropertyProductService;

    private constructor() { }

    public static get instance() {
        // Do you need arguments? Make it a regular method instead.
        return this.serviceInstance || (this.serviceInstance = new this());
    }

    public async addProductCategory(propertyId: number, productCategoryId: number)
        : Promise<boolean> {
        return apiService.patch(`/api/v1/publisher/property/${propertyId}/product/category/${productCategoryId}`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }

    public async removeProductCategory(propertyId: number, productCategoryId: number)
        : Promise<boolean> {
        return apiService.delete(`/api/v1/publisher/property/${propertyId}/product/category/${productCategoryId}`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }

    public async addBlockedBrand(blockedBrand: IPropertyBlockBrand)
        : Promise<boolean> {
        return apiService.patch(`/api/v1/publisher/property/${blockedBrand.propertyId}/product/category/${blockedBrand.productCategoryId}/block/brand`, blockedBrand)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }

    public async removeBlockedBrand(blockedBrand: IPropertyBlockBrand)
        : Promise<boolean> {
        return apiService.delete(`/api/v1/publisher/property/${blockedBrand.propertyId}/product/category/${blockedBrand.productCategoryId}/block/brand/${blockedBrand.brandId}`)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }
}

// export a singleton instance in the global namespace
export const propertyProductService = PropertyProductService.instance;
